<template>
	<v-footer height="fill-height" dark padless>
		<v-row class="d-flex flex-column justify-center">
			<v-col class="py-0">
				<footer-links></footer-links>
			</v-col>
			<v-col class="py-0">
				<sub-footer></sub-footer>
			</v-col>
		</v-row>
	</v-footer>
</template>

<script>
export default {
	data() {
		return {}
	},
	components: {
		"footer-links": require("./linksFooter").default,
		"sub-footer": require("./subFooter").default,
	},
	computed: {
		companyInfo() {
			return this.$store.getters["Footer/companyInfo"]
		},
		otherUsefulLinks() {
			return this.$store.getters["Footer/otherUsefulLinks"]
		},
		needHelpNow() {
			return this.$store.getters["Footer/needHelpNow"]
		},
		contactPoints() {
			return this.$store.getters["Footer/contactPoints"]
		},
		socialMedia() {
			return this.$store.getters["Footer/socialMedia"]
		},
		paymentMethods() {
			return this.$store.getters["Footer/paymentMethods"]
		},
	},
}
</script>

<style lang="sass" scoped>
.v-application .text-overline
	letter-spacing: -0.1px !important
.v-footer
	display: block !important
</style>
